import { LEASE_MS, LOCK_NAME, STORAGE_KEYS } from './config';

const TAB_ID = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

// Zaxira: navigator.locks bo'lmaganda localStorage'dagi muddatli belgi (lease).
function tryAcquireLease(nowMs) {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEYS.lease);
    const lease = raw ? JSON.parse(raw) : null;
    if (lease && lease.owner !== TAB_ID && lease.expiresAt > nowMs) return false;
    window.localStorage.setItem(STORAGE_KEYS.lease, JSON.stringify({ owner: TAB_ID, expiresAt: nowMs + LEASE_MS }));
    // Boshqa tab bir vaqtda yozgan bo'lsa — qayta o'qib tekshirish
    const check = JSON.parse(window.localStorage.getItem(STORAGE_KEYS.lease));
    return check?.owner === TAB_ID;
  } catch (error) {
    return true;
  }
}

function releaseLease() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEYS.lease);
    const lease = raw ? JSON.parse(raw) : null;
    if (lease?.owner === TAB_ID) window.localStorage.removeItem(STORAGE_KEYS.lease);
  } catch (error) {
    // ignore
  }
}

// fn faqat qulf olinganda bajariladi; olinmasa (boshqa tab ishlayapti) — false.
export async function withLock(fn, { locks = typeof navigator !== 'undefined' ? navigator.locks : undefined, now = Date.now } = {}) {
  if (locks && typeof locks.request === 'function') {
    return locks.request(LOCK_NAME, { ifAvailable: true }, async (lock) => {
      if (!lock) return false;
      await fn();
      return true;
    });
  }
  if (!tryAcquireLease(now())) return false;
  try {
    await fn();
    return true;
  } finally {
    releaseLease();
  }
}
